import { Component, ElementRef, Inject, OnInit, signal, ViewChild, WritableSignal } from '@angular/core';
import { FormGroup, FormControl, Validators, FormsModule, ReactiveFormsModule, AsyncValidatorFn, AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { DocumentDetailsService } from '@app/dashboard/services/document-details.service';
import { CustomCaseTypeBasedDocType, DocumentRequestModel, DocumentTypeModel, IDType, LowerCourtItem, LowerCourtParams, LowerCourtResponse, MandatoryDocument, Party, PartyModelRequest, PartyRequest, PartyResponse } from '@app/dashboard/models/document-details.model';
import { ECaseCategory, ECourtId } from '@app/dashboard/models/constant';
import { ICaseType } from '@app/dashboard/models/case-status.model';
import { CommonModule, DatePipe } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { ICourtUnitType } from '@app/dashboard/models/case-assignment.model';
import { MatTableModule } from '@angular/material/table';
import { MatRadioModule } from '@angular/material/radio';
import { DialogService } from '@app/lib/services/dialog.service';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { ILoginData } from '@app/lib/models/login.model';
import { ConfirmationDialogComponent } from '@app/confirmation-dialog/confirmation-dialog.component';
import { MatProgressSpinner, MatSpinner } from '@angular/material/progress-spinner';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { slideInOutAnimation } from '@app/shared/slide-animations';
import { CourtFormComponent } from '../court-form/court-form.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { AlphaNumSlashDirective } from '@app/shared/alpha-num-slash.directive';
import { catchError, debounceTime, distinctUntilChanged, EMPTY, filter, finalize, map, Observable, of, switchMap, take, tap } from 'rxjs';
import { AppConstantsService } from '@app/dashboard/services/app-constants.service';



@Component({
  selector: 'app-document-details',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
    MatNativeDateModule,
    MatDatepickerModule,
    MatTableModule,
    MatRadioModule,
    MatIconModule,
    MatProgressBarModule,
    ReactiveFormsModule,
    MatProgressSpinner,
    ScrollingModule,
    MatSlideToggleModule,
    CourtFormComponent,
    MatExpansionModule,
    AlphaNumSlashDirective
  ],
  templateUrl: './document-details.component.html',
  styleUrls: ['./document-details.component.scss'],
  providers: [DatePipe],
  animations: [slideInOutAnimation]
})
export class DocumentDetailsComponent implements OnInit {
  @ViewChild('searchInput') searchInput!: ElementRef;
  searchForm: FormGroup;
  searchForm2: FormGroup;
  courtOfAppealForm: FormGroup;
  trialCourtForm: FormGroup;
  isBacklogCaseParam: boolean = false;

  caseCategories: { key: string; value: string }[] = [
    { key: 'FI', value: 'First Instance' },
    { key: 'A', value: 'Appeal' },
  ];
  caseTypes: ICaseType[] = [];
  documentTypes: CustomCaseTypeBasedDocType[] = [];
  caseStages: DocumentTypeModel[] = [];
  public caseCategoryEnum = ECaseCategory;
  public divisionList: WritableSignal<ICourtUnitType[]> = signal([]);
  lowerCourtData: LowerCourtResponse | null = null;
  lowerCourts: LowerCourtItem[] = [];
  mandatoryDocuments: MandatoryDocument[] = [];
  public caseTypeList: WritableSignal<ICaseType[]> = signal([]);
  selectedCategory: string = '';
  selectedCaseType: number = 0;
  selectedDocumentType: number = 0;
  isLoading = false;
  isCaseTypeSelected = false;
  confirmDocuments = false;
  showCaseStage = false;
  // selectedCopies: number = 1;
  petitionerDisplay: string = 'ABC';
  selectedFiledOnDate: string | null = null;
  petitionerSearchName: string = '';
  plaintiffSearchName: string = '';
  defendantSearchName: string = '';
  petitionerSelectedName: string = '';
  showTable: boolean = false;
  isCheckLoading: boolean = false;
  parties: PartyRequest[] = [];
  displayedColumns: string[] = [
    'prtType', //Party Type
    'partiesId', // Party ID
    'idStructureTypeName', // ID Name
    'idStructureTypeValue', // ID Number
    'partiesFullName', // Full Name
    'select',
  ];
  partiesNameText: string = '';
  partiesPlaintiffNameText: string = '';
  partiesDefendantNameText: string = '';
  selectedRow: any = null; // Tracks the currently selected row
  isTableVisible: boolean = false;
  showTableFor: 'filedBy' | 'plaintiff' | 'defendant' | null = null;
  addPartyForm: FormGroup;
  showAddPartyForm: boolean = false; // Tracks visibility of the Add Party form
  currentAddPartySection: 'filedBy' | 'plaintiff' | 'defendant' | null = null;
  partyTypeDropdownList = [
    { key: 'Person', value: 'PRS' },
    { key: 'Corporate', value: 'CRE' },
    { key: 'Govt', value: 'GOVT' },
  ];
  idTypeList: IDType[] = [];
  isIDTypeLoading = false;
  isCaseTypeLoading = false;
  errorIDTypeMessage: string | null = null;
  courtUnitNameData: string = ''; //
  courtUnitShortNameData: string = '';
  courtUnitIdData: number = 0;
  ctpShortNameData: string = '';
  ctpIdData: number = 0;
  docTypenameData: string = '';
  docTypeIdData: number = 0;
  cptShortNameData: string | null = null;
  cptIdData: number | null = null;
  //new code
  filedByPartyType: string = '';
  plaintiffParty: Party | null = null;
  defendantParty: Party | null = null;
  partyTypeFlg: boolean = false;
  appealLowerCourtName: string = '';
  appealLowerCourtId: number | null = null;
  textOldCaseNumber: string = '';
  suitNumberData: string = '';
  caseTypeLabel: string = 'Case Type';
  isReadMode: boolean = false;
  isAddSearchFlag: boolean = false;
  caseHandlerSearchData: any[] = [];
  isValidParty: boolean = false;
  messageData: string = '';
  filteredDocumentTypes: CustomCaseTypeBasedDocType[] = [];
  searchTerm: string = '';
  maxDate: Date = new Date();
  courtIdData: number | null = null;
  isSupremeCourtFlg: boolean = false;
  isCOAFlg: boolean = false;
  isdivisionreadOnly: boolean = false;
  isDivision: string | null = null
  isDivisionId: number | null = null
  isAddLoading: boolean = false;
  isDocumentTypeLoading: boolean = false;
  isNextClicked = false;
  isCaseSaving: boolean = false;
  courtOfAppeals: any[] = [{ id: 1, name: 'Borno High Court' },
  { id: 2, name: 'Bama' },
  { id: 3, name: 'Oyo' },];
  trialCourts: any[] = [{ id: 1, name: 'Borno High Court' },
  { id: 2, name: 'Bama' },
  { id: 3, name: 'Oyo' },];
  courtOfAppealsDivision: any[] = [{ id: 1, name: 'Maidugiri' },
  { id: 2, name: 'Kaga' },
  { id: 3, name: 'Bama' },];
  trialCourtsDivisions: any[] = [{ id: 1, name: 'Maidugiri' },
  { id: 2, name: 'Kaga' },
  { id: 3, name: 'Bama' },];
  trialJudges: any[] = [];
  isAppealNumbersRequired = false;
  wordCount = 0;


  constructor(private documentDetailsService: DocumentDetailsService,
    private dialog: MatDialog,
    private dialogService: DialogService,
    public sessionConstant: AppConstantsService,
    private datePipe: DatePipe,
    public dialogRef: MatDialogRef<DocumentDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.getCourtNameData();
    if (data && data.isBacklogCase !== undefined) {
      this.isBacklogCaseParam = data.isBacklogCase;
      //console.log('Received Backlog Status from Parent:', this.isBacklogCaseParam);
    }
    this.searchForm = new FormGroup({
      // caseCategory: new FormControl({ value: '', disabled: this.isReadMode }, Validators.required),
      ...((this.isSupremeCourtFlg || this.isCOAFlg) ? { lowerCourt: new FormControl('') } : { caseCategory: new FormControl({ value: '', disabled: this.isReadMode }, Validators.required) }),
      // caseCategory: new FormControl({ value: '', disabled: this.isReadMode }, this.isSupremeCourtFlg?null:Validators.required),
      // courtDivision: new FormControl({ value: '', disabled: this.isReadMode }, { nonNullable: true }),
      courtDivision: new FormControl({ value: '', disabled: this.isReadMode }, this.isDivisionId === 0 ? Validators.required : null),
      caseType: new FormControl({ value: '', disabled: this.isReadMode }, Validators.required),
      docTypeId: new FormControl({ value: '', disabled: this.isReadMode }, Validators.required),
      // lowerCourt: new FormControl(''),

    });
    this.searchForm2 = new FormGroup({
      //docTypeId: new FormControl('', Validators.required),
      caseStageId: new FormControl({ value: '', disabled: this.isReadMode }, { nonNullable: true }),
      // selectedCopies: new FormControl(1),
      // selectedCopies: new FormControl(1, [Validators.required, Validators.min(1)]),
      partiesNameText: new FormControl('', Validators.required),
      petitionerSearchName: new FormControl('', { nonNullable: true, validators: [Validators.required] }),
      plaintiffSearchName: new FormControl('', { nonNullable: true, validators: [Validators.required] }),
      defendantSearchName: new FormControl('', { nonNullable: true, validators: [Validators.required] }),
      partiesPlaintiffNameText: new FormControl('', Validators.required),
      partiesDefendantNameText: new FormControl('', Validators.required),
      filedOn: new FormControl(new Date(), Validators.required),
      comments: new FormControl('', [this.maxWordsValidator(3500)]),
      // lowerCourt: new FormControl(''),
      ...((this.isSupremeCourtFlg || this.isCOAFlg) ? {} : { lowerCourt: new FormControl('') }),
      oldSuitNumber: new FormControl(''),
      suitNumberFormData: new FormControl(''),
      backlogCase: new FormControl(this.isBacklogCaseParam),              // for slider toggle
      backlogCaseNumber: new FormControl(
        { value: '', disabled: !this.isBacklogCaseParam },
        {
          validators: this.isBacklogCaseParam ? [Validators.pattern(/^[A-Za-z0-9/]+$/)] : [],
          asyncValidators: [this.backlogUniqueValidator()],
          updateOn: 'blur'
        }
      ),

    });
    this.courtOfAppealForm = new FormGroup({
      courtOfAppeal: new FormControl(null, Validators.required),
      divisionAtCourtOfAppeal: new FormControl('', Validators.required),
      courtOfAppealCaseNo: new FormControl('', Validators.required),
      panelOfJustices: new FormControl([], Validators.required),
      appealCourtJudgmentDate: new FormControl(null, Validators.required),
      noticeOfAppealFiledDate: new FormControl(null, Validators.required),
      transmissionOfRecordDate: new FormControl(null, Validators.required),
      serviceOfAppealRecordDate: new FormControl(null, Validators.required),
      supplementaryRecordFiled: new FormControl(false),
      supplementaryRecordDate: new FormControl(null)
    });
    this.courtOfAppealForm.get('supplementaryRecordFiled')?.valueChanges.subscribe(value => {
      const supplementaryRecordDate = this.courtOfAppealForm.get('supplementaryRecordDate');
      if (value === true) {
        supplementaryRecordDate?.setValidators([Validators.required]);
      } else {
        supplementaryRecordDate?.clearValidators();
      }
      supplementaryRecordDate?.updateValueAndValidity();
    });

    this.trialCourtForm = new FormGroup({
      trialCourt: new FormControl(null, Validators.required),
      trialCourtDivision: new FormControl(null, Validators.required),
      trialJudge: new FormControl([], Validators.required),
      trialCourtJudgementDate: new FormControl(null, Validators.required),
      serviceOfAppellantsDate: new FormControl(null, Validators.required)
    });


    this.addPartyForm = new FormGroup({
      partyType: new FormControl('PRS', Validators.required),
      partyTypeDropdown: new FormControl(''),
      partyName: new FormControl(''),
      partyGroupName: new FormControl(''),
      partyAdditionalInfo: new FormControl(''),
      partySurname: new FormControl(''),
      idType: new FormControl('', Validators.required),
      idNumber: new FormControl('', Validators.required),
    });

    // Store the isAddSearchFlag data
    if (data && data.flg !== undefined) {
      this.isAddSearchFlag = data.flg;
      //console.log('Received isAddSearchFlag:', this.isAddSearchFlag);
    }

    if (data && data.resData !== null && data.resData !== undefined) {
      this.caseHandlerSearchData = data.resData;
      //console.log('Received caseHandlerSearchData:', this.caseHandlerSearchData);
    }
  }

  ngOnInit(): void {
    //console.log('Received isAddSearchFlag from onInit:', this.isAddSearchFlag);
    //console.log('Received caseHandlerSearchData from onInit:', this.caseHandlerSearchData);
    this.handleBacklogState(this.isBacklogCaseParam);
    this.handleUnknownIDAutoFill();
    if (this.isAddSearchFlag) {
      this.getDocumentType();
      if (this.caseHandlerSearchData && this.caseHandlerSearchData.length > 0) {
        this.populateFormWithCaseHandlerData(this.caseHandlerSearchData);
      }
      this.selectedCaseType = this.caseHandlerSearchData[0].ctpId
      this.selectedCategory = this.caseHandlerSearchData[0].caseCategory;
      this.courtUnitNameData = this.caseHandlerSearchData[0].courtUnitName;
      this.courtUnitShortNameData = this.caseHandlerSearchData[0].courtUnitShortName;
      this.courtUnitIdData = this.caseHandlerSearchData[0].cutId;
      this.ctpShortNameData = this.caseHandlerSearchData[0].ctpShortName;
      this.ctpIdData = this.caseHandlerSearchData[0].ctpId;
      this.appealLowerCourtName = this.caseHandlerSearchData[0].appealCourtName;
      this.appealLowerCourtId = this.caseHandlerSearchData[0].appealCourtId;
      this.lowerCourts = [{
        id: this.caseHandlerSearchData[0].appealCourtId,
        name: this.caseHandlerSearchData[0].appealCourtName,
        auditMessage: ''
      }]
    } else {
      // this.caseTypeLabel = 'Case Type';
      if (this.isdivisionreadOnly) {
        this.courtUnitShortNameData = this.isDivision || '';
        this.courtUnitIdData = this.isDivisionId || 0;

      }
      if (this.isSupremeCourtFlg) {
        this.caseTypeLabel = 'Appeal Type';

      } else {
        this.caseTypeLabel = 'Case Type';
      }
      this.documentDetailsService.getDivisions().subscribe({
        next: (res) => {
          const divisions = res.data || res.success || [];
          this.divisionList.set(divisions);

          if (divisions.length > 0) {
            this.getCourtNameData();
          }
        },
        error: (err) => {
          console.error('Error fetching divisions:', err);
        }
      });
      this.documentDetailsService.getCaseTypes().subscribe({
        next: (res) => this.caseTypeList.set(res.data || [])
      });


      this.getCourtNameData();
      this.fetchIDTypes();
      this.addPartyForm.get('partyType')?.valueChanges.subscribe((partyType) => {
        this.resetPartyTypeFields(partyType);
      });
      this.fetchLowerCourts();
    }
    if (this.isAddSearchFlag) {
      this.confirmDocuments = true;
    }
    this.setDefaultFiledOnDate();
    // this.getCourtNameData();

    const toDate = (d: any): Date | null =>
      !d ? null : (d instanceof Date ? d : new Date(d));

    const isSameDay = (a: any, b: any): boolean => {
      const da = toDate(a), db = toDate(b);
      if (!da || !db) return false;
      return da.getFullYear() === db.getFullYear() &&
        da.getMonth() === db.getMonth() &&
        da.getDate() === db.getDate();
    };
    this.searchForm2.get('comments')!.valueChanges.subscribe(() => this.updateWordCount());
    this.updateWordCount();

    const filedOnCtrl = this.searchForm2.get('filedOn');



    // react to backlog toggle
    this.searchForm2.get('backlogCase')?.valueChanges.subscribe(isOn => {
      const c = this.searchForm2.get('backlogCaseNumber');
      if (isOn) {
        filedOnCtrl?.setValue(null);
        c?.setValidators([Validators.required, Validators.pattern(/^[A-Za-z0-9/]+$/)]);
        c?.enable({ emitEvent: false });
      } else {
        c?.clearValidators();
        c?.disable({ emitEvent: false });
        c?.reset('', { emitEvent: false });
      }
      c?.updateValueAndValidity({ emitEvent: false });
    });

  }
  ngOnChanges() {
    this.toggleBodyScroll(this.isCaseSaving);
  }
  ngOnDestroy() {
    this.toggleBodyScroll(false);
  }

  private toggleBodyScroll(disable: boolean) {
    if (disable) {
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }
  }
  get backlogCaseNumberCtrl(): AbstractControl | null {
    return this.searchForm2.get('backlogCaseNumber');
  }
  handleBacklogState(isBacklog: boolean): void {
    const filedOnCtrl = this.searchForm2.get('filedOn');
    const c = this.searchForm2.get('backlogCaseNumber');

    if (isBacklog) {
      filedOnCtrl?.setValue(null); // Clear filedOn if it's backlog
      // Set validators and enable
      c?.setValidators([Validators.required, Validators.pattern(/^[A-Za-z0-9/]+$/)]);
      c?.enable({ emitEvent: false });
    } else {
      // Clear validators and disable
      c?.clearValidators();
      c?.disable({ emitEvent: false });
      c?.reset('', { emitEvent: false });
    }
    c?.updateValueAndValidity({ emitEvent: false });
  }
  private maxWordsValidator(max: number): ValidatorFn {
    return (control: AbstractControl) => {
      const val: string = (control.value || '').toString();
      const words = this.countWords(val);
      return words > max ? { maxWords: { actual: words, max } } : null;
    };
  }

  private countWords(text: string): number {
    const t = (text ?? '').toString().trim();
    return t.length ?? 0;
  }

  updateWordCount(): void {
    const v = (this.searchForm2.get('comments')?.value ?? '').toString(); // <- key change
    this.wordCount = this.countWords(v);
  }

  fetchLowerCourts(): void {
    const params: LowerCourtParams = {
      page: 1,
      start: 0,
      limit: 25,
      property: 'id',
      direction: 'ASC',
    };

    this.documentDetailsService.getLowerCourts(params).subscribe({
      next: (response: LowerCourtResponse) => {
        this.lowerCourts = response.success;
        //console.log('Lower Courts:', this.lowerCourts);
      },
      error: (err) => {
        console.error('Error fetching lower courts:', err);
      },
    });
  }


  onLowerCourtSelect(): void {
    let selectedId: any = '';
    if (this.isSupremeCourtFlg || this.isCOAFlg) {
      selectedId = this.searchForm.get('lowerCourt')?.value;
    } else {
      selectedId = this.searchForm2.get('lowerCourt')?.value;
    }
    // const selectedId = this.searchForm2.get('lowerCourt')?.value;
    //console.log('Selected Lower Court ID:', selectedId);
    const selectedCourt = this.lowerCourts.find((court) => court.id === selectedId);
    if (selectedCourt) {
      this.appealLowerCourtName = selectedCourt.name;
      this.appealLowerCourtId = selectedCourt.id;
      //console.log('Selected Lower Court ID:', this.appealLowerCourtId);
      //console.log('Selected Lower Court Name:', this.appealLowerCourtName);
    }
  }
  getDocumentType(): void {
    if (this.isAddSearchFlag) {
      const querypatrsm: any = {
        "caseId": this.caseHandlerSearchData[0].casePhaseCasId,
        "parentDocId": this.caseHandlerSearchData[0].docTypeId,
        "appealTypeId": this.caseHandlerSearchData[0].ctpId,
        "caseNumber": this.caseHandlerSearchData[0].courtCaseNumber
      }
      this.isLoading = true;
      this.documentDetailsService.getDocumentTypesAdd(querypatrsm).subscribe({
        next: (response) => {
          // Map the API response to match the CustomCaseTypeBasedDocType interface
          this.documentTypes = (response.success || []).map((doc: any) => ({
            docmentTypeId: doc.docTypeId,
            docmentTypeName: doc.docTypeName,
            cptId: doc.cptId || 0, // Fallback to 0 if null or undefined
            transType: doc.transType || '', // Fallback to empty string
            auditMessage: doc.auditMessage || '' // Fallback to empty string
          }));
          this.filteredDocumentTypes = [...this.documentTypes].sort((a, b) =>
            a.docmentTypeName.localeCompare(b.docmentTypeName));
          //console.log('Mapped Document Types:', this.documentTypes);
          this.isLoading = false;
        },
        error: (err) => {
          console.error('Error fetching document types:', err);
          this.isLoading = false;
        },
      });
    }
  }

  getSupremCourtDocType(): void {
    if (this.selectedCaseType !== null && this.selectedCaseType !== undefined) {
      this.isLoading = true;
      this.documentDetailsService.getSupremeCourtDocumentTypes(this.selectedCaseType).subscribe({
        next: (response) => {
          // this.documentTypes = response.success || [];
          this.documentTypes = (response.success || []).map((doc: any) => ({
            docmentTypeId: doc.docTypeId,
            docmentTypeName: doc.docTypeName,
            cptId: doc.cptId || 0, // Fallback to 0 if null or undefined
            transType: doc.transType || '', // Fallback to empty string
            auditMessage: doc.auditMessage || '' // Fallback to empty string
          }));
          this.filteredDocumentTypes = [...this.documentTypes].sort((a, b) =>
            a.docmentTypeName.localeCompare(b.docmentTypeName));
          this.isLoading = false;
        },
        error: (err) => {
          console.error('Error fetching document types:', err);
          this.isLoading = false;
        },
      })
    }
  }

  get canProceed(): boolean {
    // ensure latest validity after dynamic validators
    this.searchForm.updateValueAndValidity({ emitEvent: false });
    this.searchForm2.updateValueAndValidity({ emitEvent: false });
    // If SC needs extra forms before Next, include them; otherwise drop that part


    return this.searchForm.valid
      && this.searchForm2.valid

  }
  get canSave(): boolean {
    // keep validity fresh if you really need it here
    this.searchForm.updateValueAndValidity({ emitEvent: false });
    this.searchForm2.updateValueAndValidity({ emitEvent: false });

    // Only enforce extraOk after Next is clicked
    const extraOk =
      !this.isNextClicked ||                                  // before Next → ignore extra forms
      (!this.isSupremeCourtFlg ||                             // after Next:
        (this.courtOfAppealForm?.valid && this.trialCourtForm?.valid));

    return this.searchForm.valid &&
      this.searchForm2.valid && !this.searchForm2.pending &&
      extraOk;
  }

  fetchDocumentTypes(): void {
    if (this.selectedCategory && this.selectedCategory.trim().length > 0 && this.selectedCaseType !== null && this.selectedCaseType !== undefined && this.selectedCaseType !== 0) {
      this.isDocumentTypeLoading = true;
      this.documentDetailsService.getDocumentTypes(this.selectedCaseType, this.selectedCategory).subscribe({
        next: (response) => {
          this.documentTypes = response.success || [];
          this.filteredDocumentTypes = [...this.documentTypes].sort((a, b) =>
            a.docmentTypeName.localeCompare(b.docmentTypeName));
          this.isDocumentTypeLoading = false;
        },
        error: (err) => {
          console.error('Error fetching document types:', err);
          this.isDocumentTypeLoading = false;
        },
      });
    }
  }

  onCaseCategoryChange(event: MatSelectChange): void {
    this.selectedCategory = event.value;
    //console.log('Selected Case Category:', this.selectedCategory);
    this.caseTypeLabel = this.selectedCategory !== 'FI' ? 'Appeal Type' : 'Case Type';
    this.searchForm.patchValue({
      courtDivision: '',
      caseType: '',
      docTypeId: '',
    });
    this.caseTypes = [];
    this.mandatoryDocuments = [];
    this.documentTypes = [];
  }

  onCaseTypeChange(event: MatSelectChange): void {
    this.mandatoryDocuments = [];
    this.documentTypes = [];
    this.filteredDocumentTypes = [];
    this.caseStages = [];

    // 2. Reset the Form Controls for Document Type and Case Stage
    this.searchForm.get('docTypeId')?.reset();
    this.searchForm2.get('caseStageId')?.reset();
    this.selectedCaseType = event.value.id;
    this.isCaseTypeSelected = true;
    //console.log('Selected Case Category:', this.selectedCaseType);
    const selectedCaseTypeData = event.value;
    if (selectedCaseTypeData) {
      //console.log('Selected CaseType Details:', selectedCaseTypeData);
      this.ctpShortNameData = selectedCaseTypeData.shortName;
      this.ctpIdData = selectedCaseTypeData.id;

    } else {
      //console.log('No case type selected');
    }
    this.checkAndFetchDocumentTypes();
  }
  checkAndFetchDocumentTypes(): void {
    if (!this.isSupremeCourtFlg && (this.selectedCategory && this.selectedCaseType)) {
      this.fetchDocumentTypes();
    } else if (this.isSupremeCourtFlg || this.isCOAFlg) {
      const notice = this.courtOfAppealForm.get('noticeOfAppealFiledDate');
      const transmission = this.courtOfAppealForm.get('transmissionOfRecordDate');
      const service = this.courtOfAppealForm.get('serviceOfAppealRecordDate');
      if (this.isSupremeCourtFlg && this.ctpShortNameData === 'ML') {
        notice?.clearValidators();
        transmission?.clearValidators();
        service?.clearValidators();

        notice?.updateValueAndValidity();
        transmission?.updateValueAndValidity();
        service?.updateValueAndValidity();
      } else {
        notice?.setValidators([Validators.required]);
        transmission?.setValidators([Validators.required]);
        service?.setValidators([Validators.required]);

        notice?.updateValueAndValidity();
        transmission?.updateValueAndValidity();
        service?.updateValueAndValidity();
      }
      this.getSupremCourtDocType();
    }
  }

  saveNext() {
    if (this.confirmDocuments) {
      this.dialogService.openDialog1({
        data: {
          title: "Information",
          message: 'Saved Successfully!',
          icon: 'info', // ✅ Default icon if not provided
        }, disableClose: true,           // Prevents closing on outside click or ESC
        hasBackdrop: true,            // Shows backdrop to block interaction
        backdropClass: 'dialog-backdrop', // Optional: custom styling
      });
      this.dialogRef.close(true);
    } else {
      this.dialogService.openDialog1({
        data: {
          title: "Information",
          message: 'Please confirm the mandatory documents.',
          icon: 'info', // ✅ Default icon if not provided
        }, disableClose: true,           // Prevents closing on outside click or ESC
        hasBackdrop: true,            // Shows backdrop to block interaction
        backdropClass: 'dialog-backdrop', // Optional: custom styling
      });
    }
  }

  close() {
    this.dialogRef.close(false);
  }
  handleUnknownIDAutoFill(): void {
    this.addPartyForm.get('idType')?.valueChanges.subscribe((selectedIdType) => {
      const selectedType = this.idTypeList.find(type => type.id === selectedIdType);

      if (selectedType?.name === 'Unknown ID') {
        const autoGeneratedId = this.generateUniqueIdNumber();
        this.addPartyForm.get('idNumber')?.setValue(autoGeneratedId);
        this.addPartyForm.get('idNumber')?.disable(); // 🔒 Disable input field
      } else {
        this.addPartyForm.get('idNumber')?.reset();
        this.addPartyForm.get('idNumber')?.enable(); // 🔓 Enable input field for other types
      }
    });
  }

  generateUniqueIdNumber(): string {
    const name = this.addPartyForm.get('partyName')?.value || '';
    const surname = this.addPartyForm.get('partySurname')?.value || '';
    const namePart = name.substring(0, 5).toUpperCase();
    const surnamePart = surname.substring(0, 5).toUpperCase();
    const timestamp = Date.now();

    return `${namePart}${surnamePart}${timestamp}`;
  }


  onDocumentTypeChange(event: MatSelectChange): void {
    // ✅ Guard against undefined/null event or value
    if (!event || !event.value) {
      //console.log('No document type selected or event is undefined');
      return;
    }

    this.mandatoryDocuments = [];
    this.selectedDocumentType = event.value.docmentTypeId;
    //console.log('Selected Document Type:', this.selectedDocumentType);

    const selectedDocumentTypeData = event.value;
    //console.log('Selected DocumentType Details:', selectedDocumentTypeData);

    this.docTypenameData = selectedDocumentTypeData.docmentTypeName;
    this.docTypeIdData = selectedDocumentTypeData.docmentTypeId;
    const docType = (selectedDocumentTypeData.documentTypeName || '').toLowerCase();

    const isNoticeOfAppeal = (selectedDocumentTypeData.docmentTypeName || '').toLowerCase().includes('record of appeal');

    if (this.isSupremeCourtFlg) {
      this.applyAppealNumberValidators(isNoticeOfAppeal);
    }

    this.fetchChecklistDoc();
    this.checkAndFetchCaseStages();
  }

  private applyAppealNumberValidators(required: boolean): void {

    this.isAppealNumbersRequired = required;

    const oldSuitCtrl = this.searchForm2.get('oldSuitNumber');
    const suitCtrl = this.searchForm2.get('suitNumberFormData');

    if (!oldSuitCtrl || !suitCtrl) return;

    if (required) {
      oldSuitCtrl.setValidators([Validators.required]);
      suitCtrl.setValidators([Validators.required]);
    } else {
      oldSuitCtrl.clearValidators();
      suitCtrl.clearValidators();
    }

    oldSuitCtrl.updateValueAndValidity();
    suitCtrl.updateValueAndValidity();
  }

  fetchChecklistDoc(): void {
    this.isCheckLoading = true;
    if (this.selectedDocumentType !== null && this.selectedCategory && this.selectedCaseType) {
      const reqBody = {
        'documentTypeId': this.selectedDocumentType,
        'caseCategory': this.selectedCategory,
        'appealTypeId': this.selectedCaseType
      }
      this.documentDetailsService.getChecklistDoc(reqBody).subscribe({
        next: (response) => {
          this.mandatoryDocuments = response.success
          this.isCheckLoading = false;
        },
        error: (err) => {
          console.error('Error fetching case stage:', err);
          this.isCheckLoading = false;
        },
      });
    }
    this.isCheckLoading = false;
  }
  stopKeyEvent(event: KeyboardEvent): void {
    // Always stop propagation to prevent mat-select behavior
    event.stopImmediatePropagation();

    // Allow space to be typed but prevent mat-select from reacting to it
    if (event.key === ' ') {
      event.stopPropagation(); // prevent option selection
      return; // allow default (typing space)
    }

    // Block selection keys
    if (['Enter', 'ArrowUp', 'ArrowDown'].includes(event.key)) {
      event.preventDefault();
      event.stopPropagation();
    }
  }




  checkAndFetchCaseStages(): void {
    if (!this.isSupremeCourtFlg && (this.selectedCategory && this.selectedDocumentType && this.selectedCaseType)) {
      this.fetchCaseStages();
    } else if (this.isSupremeCourtFlg || this.isCOAFlg) {
      this.fetchCaseStages();
    }
  }

  fetchCaseStages(): void {
    if (this.selectedDocumentType !== null && this.selectedDocumentType !== undefined && this.selectedDocumentType !== 0) {
      this.documentDetailsService.getCaseStages(this.selectedDocumentType).subscribe({
        next: (response) => {
          this.caseStages = response.data || [];
          this.onCaseStageChange(this.caseStages[0].documentTypeCasePhaseTypeId || 0);
          this.searchForm2.patchValue({ caseStageId: this.caseStages[0].documentTypeCasePhaseTypeId });
        },
        error: (err) => {
          console.error('Error fetching case stage:', err);
          this.isLoading = false;
        },
      });
    }
  }

  onNext(): void {
    this.isReadMode = true;
    if (this.confirmDocuments) {
      this.showCaseStage = true;
    } else {
      alert('Please confirm the mandatory fields.');
    }
  }


  onSave(): void {
    // 1) Pre-validate
    if (this.sessionConstant?.HC_COURT_LEVEL_ID !== this.sessionConstant.COURT_LEVEL) {
      const isInvalidDocType = this.validateDocuments();

      if (isInvalidDocType) {
        const docTypeName = this.docTypenameData ?? 'Selected Document';
        const caseLabel = this.sessionConstant.COURT_CASE_LABEL ?? 'case';

        this.dialogService.openDialog1({
          data: {
            title: 'Info',
            message: `'${docTypeName}' is not the first document for ${caseLabel} initiation`,
            icon: 'info'
          },
          disableClose: true,
          hasBackdrop: true,
          backdropClass: 'dialog-backdrop',
        });
        return; // Stop execution, matching the ExtJS behavior
      }
    }
    this.validateParties();
    this.searchForm.get('caseCategory')?.clearValidators();
    this.searchForm.get('caseCategory')?.updateValueAndValidity();

    // If parties validation fails, show dialog & stop
    if (this.isValidParty) {
      this.dialogService.openDialog1({
        data: { title: 'Failed', message: this.messageData, icon: 'error' },
        disableClose: true,
        hasBackdrop: true,
        backdropClass: 'dialog-backdrop',
      });
      return;
    }




    // 2) Confirm main action
    this.openConfirm('Confirm Action', 'Do you want to Save?')
      .pipe(
        take(1),
        filter((confirmed) => {
          if (!confirmed) {
            //console.log('Save cancelled by user.');
            return false;
          }
          return true;
        }),
        // 3) Form validations after confirmation
        switchMap(() => {
          if (!(this.searchForm.valid && this.searchForm2.valid)) {
            this.dialogService.openDialog1({
              data: { title: 'Info', message: 'Please fill all required fields.', icon: 'info' },
              disableClose: true,
              hasBackdrop: true,
              backdropClass: 'dialog-backdrop',
            });
            return EMPTY;
          }

          // Supplementary record rule
          const supplementaryFiled = this.courtOfAppealForm.get('supplementaryRecordFiled')?.value === true;
          const supplementaryDate = this.courtOfAppealForm.get('supplementaryRecordDate')?.value;
          if (supplementaryFiled && !supplementaryDate) {
            this.dialogService.openDialog1({
              data: {
                title: 'Info',
                message: 'Supplementary Record Date is required when record is filed.',
                icon: 'info',
              },
              disableClose: true,
              hasBackdrop: true,
              backdropClass: 'dialog-backdrop',
            });
            console.error('Supplementary Record Date is required.');
            return EMPTY;
          }

          // 4) Prepare payload (first attempt without noBriefsFlag confirmation)
          const count: number = this.caseHandlerSearchData.length - 1;
          let requestPayload: DocumentRequestModel = {
            ...this.prepareRequestPayload(count),
            // first try without forcing the flag; backend will tell us if we need user confirmation
            noBriefsFlag: false,
          };

          //console.log('Prepared payload:', requestPayload);
          this.isCaseSaving = true;

          // 5) First save
          return this.documentDetailsService.upsertDocument(requestPayload).pipe(
            // 6) If backend says briefs missing (and not HC), ask user and re-submit with noBriefsFlag: true
            switchMap((response: any) => {
              const courtType = response?.data?.courtType;
              const backendNoBriefsFlag = !!response?.data?.noBriefsFlag;
              const validString: string = response?.data?.validString ?? '';

              // Only for non-HC and when backend indicates missing briefs
              if (courtType !== 'HC' && backendNoBriefsFlag) {
                const msg = this.mapNoBriefsMessage(validString);
                if (msg) {
                  return this.openConfirm('Confirm Action', msg).pipe(
                    take(1),
                    switchMap((confirmed) => {
                      if (!confirmed) {
                        //console.log('Save cancelled by user on noBriefsFlag confirmation.');
                        return EMPTY;
                      }
                      // Resubmit with noBriefsFlag: true
                      requestPayload = { ...requestPayload, noBriefsFlag: true };
                      return this.documentDetailsService.upsertDocument(requestPayload).pipe(
                        tap((secondResp: any) => {
                          // Show info dialogs after successful second save
                          this.showInfoChain(secondResp?.data?.validString || '');
                          // Close and reset
                          this.dialogRef?.close(secondResp?.data?.courtCaseNumber);
                          this.resetFormData();
                        })
                      );
                    })
                  );
                }
              }

              // If no secondary confirmation needed, proceed with info + close
              return of(response).pipe(
                tap((resp) => {
                  this.showInfoChain(resp?.data?.validString || '');
                  this.dialogRef?.close(resp?.data?.courtCaseNumber);
                  this.resetFormData();
                })
              );

            }),
            catchError((err) => {
              console.error('Error saving document:', err);
              this.dialogService.openDialog1({
                data: { title: 'Error', message: 'Failed to save the document. Please try again.', icon: 'error' },
                disableClose: true,
                hasBackdrop: true,
                backdropClass: 'dialog-backdrop',
              });
              return EMPTY;
            }),
            finalize(() => {
              this.isCaseSaving = false;
              if (this.data && this.data.onRefreshTasks) {
                this.data.onRefreshTasks();
              }
            })
          );
        })
      )
      .subscribe();
  }

  /** Helper: one-line confirm dialog -> Observable<boolean> */
  private openConfirm(title: string, message: string) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: { title, message },
      disableClose: true,
      hasBackdrop: true,
      backdropClass: 'dialog-backdrop',
    });
    return dialogRef.afterClosed();
  }

  /** Helper: map backend validString to user-facing message */
  private mapNoBriefsMessage(validString: string): string | null {
    if (!validString) return null;

    if (validString === 'No Briefs recorded') {
      return "Appellant's and Respondent's Brief documents are not recorded, Do you want to proceed?";
    }
    if (validString === 'Appellant Brief is not recorded') {
      return "Appellant's Brief document is not recorded, Do you want to proceed?";
    }
    if (validString === 'Respondent Brief is not recorded') {
      return "Respondent's Brief document is not recorded, Do you want to proceed?";
    }
    // Unknown phrase from backend – fall back to showing it directly for clarity
    return validString;
  }

  /** Helper: show info dialogs in sequence */
  private showInfoChain(primaryMessage: string): void {
    const infoDialog = this.dialogService.openDialog1({
      data: { title: 'Info', message: primaryMessage, icon: 'info' },
      disableClose: true,
      hasBackdrop: true,
      backdropClass: 'dialog-backdrop',
    });

    infoDialog.afterClosed().subscribe(() => {
      this.dialogService.openDialog1({
        data: {
          title: 'Information',
          message: 'You may now attach any documents if required',
          icon: 'warning',
        },
        disableClose: true,
        hasBackdrop: true,
        backdropClass: 'dialog-backdrop',
      });
    });
  }

  get lowerCourtDisplayName(): string {
    const id = this.searchForm.get('lowerCourt')?.value || this.searchForm2.get('lowerCourt')?.value;
    return this.lowerCourts.find(c => c.id === id)?.name || this.appealLowerCourtName || '';
  }
  private backlogUniqueValidator(): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
      const value = (control.value || '').trim();
      const backlogOn = this.searchForm2?.get('backlogCase')?.value;

      if (!backlogOn || !value) return of(null);

      return of(value).pipe(
        debounceTime(50),
        distinctUntilChanged(),
        switchMap(v =>
          this.documentDetailsService.getBacklogCaseNumberExist(v).pipe(
            map(res => {
              // Backend returns { exists: boolean }
              // If it exists -> ERROR (duplicate). If not -> OK.
              return res?.isBacklogCase ? { alreadyExists: true } : null;
            }),
            catchError(() => of({ server: true }))
          )
        )
      );
    };
  }

  onNextClick(): void {
    this.validateParties();
    this.searchForm.get('caseCategory')?.clearValidators();

    // Show failure dialog if validation fails
    if (this.isValidParty) {
      this.dialogService.openDialog1({
        data: {
          title: "Failed",
          message: this.messageData,
          icon: 'error',
        }, disableClose: true,           // Prevents closing on outside click or ESC
        hasBackdrop: true,            // Shows backdrop to block interaction
        backdropClass: 'dialog-backdrop', // Optional: custom styling
      });
      return; // Stop execution if validation fails
    }
    if (this.searchForm2.get('backlogCase')?.value === true && !this.searchForm2.get('backlogCaseNumber')?.value) {
      this.searchForm2.get('backlogCaseNumber')?.setErrors({ required: true });
      this.dialogService.openDialog1({
        data: {
          title: "Failed",
          message: "Required Backlog Case Number",
          icon: 'error',
        }, disableClose: true,           // Prevents closing on outside click or ESC
        hasBackdrop: true,            // Shows backdrop to block interaction
        backdropClass: 'dialog-backdrop', // Optional: custom styling
      });
      return;
    }

    this.isNextClicked = true;
    this.isReadMode = true;

  }
  onPreviousClick() {
    this.isNextClicked = false;
    this.isReadMode = false; // Reset read mode to false
  }

  prepareRequestPayload(index?: number): DocumentRequestModel {
    this.textOldCaseNumber = this.searchForm2.get('oldSuitNumber')?.value;
    this.suitNumberData = this.searchForm2.get('suitNumberFormData')?.value;
    return {
      courtUnitName: this.courtUnitNameData,
      courtUnitId: this.isAddSearchFlag ? this.caseHandlerSearchData[index || 0].courtUnitId : this.courtUnitIdData.toString(),
      appealCourtName: this.appealLowerCourtName || "",
      appealCourtId: this.appealLowerCourtId?.toString() || '',
      ctpShortName: this.ctpShortNameData,
      ctpId: this.ctpIdData?.toString() || '',
      docTypename: this.docTypenameData,
      docTypeId: this.docTypeIdData.toString(),
      cptShortName: this.cptShortNameData?.toString() || '',
      cptId: this.cptIdData?.toString() || '',
      courtCaseNumber: !this.isAddSearchFlag ? '' : this.caseHandlerSearchData[index || 0].courtCaseNumber,
      casePhaseId: !this.isAddSearchFlag ? '' : this.caseHandlerSearchData[index || 0].casePhaseId,
      docId: !this.isAddSearchFlag ? '' : this.caseHandlerSearchData[index || 0].docId,
      casePhaseCasId: !this.isAddSearchFlag ? '' : this.caseHandlerSearchData[index || 0].casePhaseCasId,
      partiesByPrtIdReallyIssuedBy: this.searchForm2.get('petitionerSearchName')?.value,
      partiesByPrtIdReallyIssuedByName: this.searchForm2.get('partiesNameText')?.value,
      filedByPartyIdPartyType: this.filedByPartyType,
      partiesByPrtIdIssuedBy: this.searchForm2.get('plaintiffSearchName')?.value,
      partiesByPrtIdIssuedByName: this.searchForm2.get('partiesPlaintiffNameText')?.value,
      appellentPartyIdPartyType: this.plaintiffParty?.prtType ?? '',
      appGroupGovtFlag: this.plaintiffParty?.govtPartyInGroup ?? '',
      partyIdCharging: this.searchForm2.get('defendantSearchName')?.value,
      partyIdChargingName: this.searchForm2.get('partiesDefendantNameText')?.value,
      respondentFieldIdPartyType: this.defendantParty?.prtType ?? '',
      respGroupGovtFlag: this.defendantParty?.govtPartyInGroup ?? '',
      comments: this.searchForm2.get('comments')?.value,
      isTrackingNumber: '',
      restrictionName: 'Unrestricted',
      restrictionId: 2,
      receiptTypeName: 'Hand',
      receiptTypeId: 1,
      // numberOfCopies: this.selectedCopies,
      numberOfCopies: !this.isAddSearchFlag ? "1" : this.caseHandlerSearchData[index || 0].numberOfCopies ?? '1',
      dateReceived: this.selectedFiledOnDate,
      dateMailed: this.selectedFiledOnDate || "",
      // oldCaseNumber: '',
      // suitNumber: this.textSuitNumber,
      oldCaseNumber: this.textOldCaseNumber,
      suitNumber: this.suitNumberData,
      triggeredTaskId: !this.isAddSearchFlag ? "" : this.caseHandlerSearchData[index || 0].triggeredTaskId || '',
      triggeredTaskDetails: '',
      cutId: '',
      hearingCourtUnitName: !this.isAddSearchFlag ? "" : this.caseHandlerSearchData[index || 0].hearingCourtUnitName || "",
      hearingCourtUnitId: !this.isAddSearchFlag ? "" : this.caseHandlerSearchData[index || 0].hearingCourtUnitId || '',
      transType: 'I',
      documentsGridAddMessage: 'ADD',
      uploadDateReceived: '',
      // courtType: 'HC',
      // courtType: this.isSupremeCourtFlg? 'SC':'HC',
      courtType: this.isSupremeCourtFlg ? 'SC' : (this.isCOAFlg ? 'CA' : 'HC'),
      caseCategory: this.selectedCategory,
      courtUnitShortName: this.courtUnitShortNameData,
      backlogCaseFlag: this.searchForm2.get('backlogCase')?.value || false,
      backlogCaseNumber: this.searchForm2.get('backlogCaseNumber')?.value || '',
      appealRecordDto: this.isSupremeCourtFlg && !this.isAddSearchFlag && this.courtOfAppealForm.valid && this.trialCourtForm.valid ? {
        courtOfAppealName: this.courtOfAppealForm.get('courtOfAppeal')?.value.name || '',
        courtOfAppealId: this.courtOfAppealForm.get('courtOfAppeal')?.value.id ?? null,
        appealDivisionName: this.courtOfAppealForm.get('divisionAtCourtOfAppeal')?.value.name || '',
        appealDivisionId: this.courtOfAppealForm.get('divisionAtCourtOfAppeal')?.value.id ?? null,
        appealCaseNo: this.courtOfAppealForm.get('courtOfAppealCaseNo')?.value || '',
        coaJustices: this.courtOfAppealForm.get('panelOfJustices')?.value || [],
        appealJudgmentDate: this.datePipe.transform(this.courtOfAppealForm.get('appealCourtJudgmentDate')?.value, 'yyyy-MM-dd') || '',
        noticeFiledDate: this.datePipe.transform(this.courtOfAppealForm.get('noticeOfAppealFiledDate')?.value, 'yyyy-MM-dd') || '',
        transmissionDate: this.datePipe.transform(this.courtOfAppealForm.get('transmissionOfRecordDate')?.value, 'yyyy-MM-dd') || '',
        appealServiceDate: this.datePipe.transform(this.courtOfAppealForm.get('serviceOfAppealRecordDate')?.value, 'yyyy-MM-dd') || '',
        supplementaryFiled: this.courtOfAppealForm.get('supplementaryRecordFiled')?.value ?? false,
        supplementaryFiledDate: this.datePipe.transform(this.courtOfAppealForm.get('supplementaryRecordDate')?.value, 'yyyy-MM-dd') || '',

        trialCourtId: this.trialCourtForm.get('trialCourt')?.value.id ?? null,
        trialCourtName: this.trialCourtForm.get('trialCourt')?.value.name || '',
        trialCourtDivisionId: this.trialCourtForm.get('trialCourtDivision')?.value.id ?? null,
        trialCourtDivisionName: this.trialCourtForm.get('trialCourtDivision')?.value.name || '',
        trailJudges: this.trialCourtForm.get('trialJudge')?.value || [],
        trialJudgmentDate: this.datePipe.transform(this.trialCourtForm.get('trialCourtJudgementDate')?.value, 'yyyy-MM-dd') || '',
        appellantServiceDate: this.datePipe.transform(this.trialCourtForm.get('serviceOfAppellantsDate')?.value, 'yyyy-MM-dd') || '',

        // optional fields (you can fill from some caseData object if needed)
        suitReferenceKey: '',
        casereqId: '',
        caseId: '',
        createdByApp: '',
        createdAt: '',

      } : null
    };
  }

  onFiledBySearch(): void {
    this.isTableVisible = true; // Show the table
    this.showAddPartyForm = false; // Hide the "Selected Party Type" form
    this.currentAddPartySection = 'filedBy';
    const searchText = this.searchForm2.get('partiesNameText')?.value;
    if (searchText?.trim()) {
      this.performSearch('filedBy', searchText);
    } else {
      //console.log('Enter a valid search term for Filed By/ Petitioner(s).');
    }
  }


  onPlaintiffSearch(): void {
    this.isTableVisible = true; // Show the table
    this.showAddPartyForm = false; // Hide the "Selected Party Type" form
    this.currentAddPartySection = 'plaintiff';
    const searchText = this.searchForm2.get('partiesPlaintiffNameText')?.value;
    if (searchText?.trim()) {
      this.performSearch('plaintiff', searchText);
    } else {
      //console.log('Enter a valid search term for Plaintiff(s)/Claimant(s).');
    }
  }

  onDefendantSearch(): void {
    this.isTableVisible = true; // Show the table
    this.showAddPartyForm = false; // Hide the "Selected Party Type" form
    this.currentAddPartySection = 'defendant';
    const searchText = this.searchForm2.get('partiesDefendantNameText')?.value;
    if (searchText?.trim()) {
      this.performSearch('defendant', searchText);
    } else {
      //console.log('Enter a valid search term for Defendant(s).');
    }
  }

  // onDateChange(event: any): void {
  //   // this.selectedFiledOnDate = this.searchForm2.get('filedOn')?.value;
  //   const rawDate = event.value;
  //   const formattedDate = this.datePipe.transform(rawDate, 'dd-MMM-yyyy');
  //   this.selectedFiledOnDate = formattedDate;
  //   //console.log('Selected Date:', this.selectedFiledOnDate);
  // }


  onDateChange(event: any): void {
    const rawDate = event.value;
    if (rawDate) {
      this.selectedFiledOnDate = this.datePipe.transform(rawDate, 'dd-MMM-yyyy');
      this.searchForm2.patchValue({ filedOn: rawDate });
      //console.log('Selected Filed On Date:', this.selectedFiledOnDate);
    }
  }

  onRowSelected(row: any, checked: boolean): void {
    if (checked) {
      this.selectedRow = row; // Set the current row as selected
    } else {
      this.selectedRow = null; // Deselect the row
    }
  }

  // Add selected row
  addSelectedRow(): void {
    this.partyTypeFlg = true;
    if (this.selectedRow) {
      //console.log('Added Row:', this.selectedRow);

      if (this.showTableFor === 'filedBy') {
        this.searchForm2.patchValue({
          petitionerSearchName: this.selectedRow.partiesId, // Party ID
          partiesNameText: this.selectedRow.partiesFullName, // Full Name
        });
        this.performSearch('filedBy', this.selectedRow.partiesFullName);
      } else if (this.showTableFor === 'plaintiff') {
        this.searchForm2.patchValue({
          plaintiffSearchName: this.selectedRow.partiesId, // Party ID
          partiesPlaintiffNameText: this.selectedRow.partiesFullName, // Full Name
        });
        this.performSearch('plaintiff', this.selectedRow.partiesFullName);
      } else if (this.showTableFor === 'defendant') {
        this.searchForm2.patchValue({
          defendantSearchName: this.selectedRow.partiesId, // Party ID
          partiesDefendantNameText: this.selectedRow.partiesFullName, // Full Name
        });
        this.performSearch('defendant', this.selectedRow.partiesFullName);
      }

      // this.validateParties();
      this.closeTable();
    }
  }

  //plaintiffSearchName
  addPlaintiffSelectedRow(): void {
    if (this.selectedRow) {
      //console.log('Added Row:', this.selectedRow);
      this.searchForm2.patchValue({
        plaintiffSearchName: this.selectedRow.partiesId, // Party ID
        partiesPlaintiffNameText: this.selectedRow.partiesFullName, // Full Name
      });
      this.closeTable();
    }
  }

  // Close the table
  closeTable(): void {
    this.isTableVisible = false; // Hide the table
    this.currentAddPartySection = null;
    this.selectedRow = null; // Clear selection
    this.showTableFor = null;
    //console.log('Table closed.');
  }

  performSearch(section: 'filedBy' | 'plaintiff' | 'defendant', searchText: string): void {
    this.isTableVisible = false; // Hide table initially
    this.selectedRow = null; // Clear selection

    const requestPayload: PartyRequest = {
      partiesName: searchText,
      partiesId: '',
      isCourtStaff: 'N',
    };

    this.documentDetailsService.fetchParties(requestPayload).subscribe({
      next: (response: PartyResponse) => {
        this.parties = response.data;
        this.showTableFor = section; // Show table for the correct section
        this.isTableVisible = true;
        if (this.partyTypeFlg && section === 'filedBy') {
          //console.log(`searchText:: ${searchText}`);
          const partyIdData = response.data.find(obj => obj.partiesFullName === searchText);
          if (partyIdData) {
            this.filedByPartyType = partyIdData.prtType;
            //console.log(`filedByPartyType :: ${this.filedByPartyType}`);
          } else {
            //console.log(`No DATA`);
          }
          this.isTableVisible = false;
          this.partyTypeFlg = false;
        } else if (this.partyTypeFlg && section === 'plaintiff') {
          //console.log(`searchText:: ${searchText}`);
          const partyIdData = response.data.find(obj => obj.partiesFullName === searchText);
          if (partyIdData) {
            this.plaintiffParty = partyIdData;
            //console.log(`plaintiffPartyType :: ${this.plaintiffParty}`);
            // if (partyIdData.prtType === 'GRP') {
            //   this.getGovtPartyInGroup(section, partyIdData)
            // }
          } else {
            //console.log(`No DATA`);
          }
          this.isTableVisible = false;
          this.partyTypeFlg = false;
        } else if (this.partyTypeFlg && section === 'defendant') {
          //console.log(`searchText:: ${searchText}`);
          const partyIdData = response.data.find(obj => obj.partiesFullName === searchText);
          if (partyIdData) {
            this.defendantParty = partyIdData;
            //console.log(`defendantPartyType :: ${this.defendantParty}`);
            // if (partyIdData.prtType === 'GRP') {
            //   this.getGovtPartyInGroup(section, partyIdData)
            // }
          } else {
            //console.log(`No DATA`);
          }
          this.isTableVisible = false;
          this.partyTypeFlg = false;
        } else {
          //console.log(`partyIdData no Data`);
        }
      },
      error: (error) => {
        console.error('Error fetching parties:', error);
      },
    });
  }

  // getGovtPartyInGroup(section: 'plaintiff' | 'defendant', party: Party): void {
  //   this.isTableVisible = false; // Hide table initially
  //   this.selectedRow = null; // Clear selection

  //   const requestPayload = {
  //     partiesId: party.partiesId,
  //     prtType: party.prtType
  //   };

  //   this.documentDetailsService.getGroupParty(requestPayload).subscribe({
  //     next: (response: any) => {
  //       const govtGroupVal = response?.success?.govtPartyInGroup ?? response?.data?.[0]?.govtPartyInGroup;
  //       if (section === 'plaintiff') {
  //         if (govtGroupVal !== undefined) {
  //           if (this.plaintiffParty) {
  //             this.plaintiffParty.govtPartyInGroup = govtGroupVal;
  //           }
  //           //console.log('plaintiffParty updated ::', this.plaintiffParty);
  //         } else {
  //           //console.log('No govtPartyInGroup data found for plaintiff');
  //         }

  //       } else if (section === 'defendant') {
  //         if (govtGroupVal !== undefined) {
  //           if (this.defendantParty) {
  //             this.defendantParty.govtPartyInGroup = govtGroupVal;
  //           }
  //           //console.log('defendantParty updated ::', this.defendantParty);
  //         } else {
  //           //console.log('No govtPartyInGroup data found for defendant');
  //         }
  //       } else {
  //         //console.log(`partyIdData no Data`);
  //       }
  //     },
  //     error: (error) => {
  //       console.error('Error fetching parties:', error);
  //     },
  //   });
  // }
  // Show Add Party form
  showAddParty(section: 'filedBy' | 'plaintiff' | 'defendant'): void {
    this.isTableVisible = false; // Hide the table
    this.showAddPartyForm = true;
    this.currentAddPartySection = section;
    // this.addPartyForm.reset(); // Reset the form each time it's opened
    this.addPartyForm.reset({
      partyType: 'PRS', // Reset partyType to "PRS" (Person) as default
      partyTypeDropdown: '',
      partyName: '',
      // partyHeadName: '',
      // partyHeadSurname: '',
      partyGroupName: '',
      partyAdditionalInfo: '',
      partySurname: '',
      idType: '',
      idNumber: '',
    });
    //console.log('Add Party Form Opened'); // Debug message
  }

  // Cancel Add Party form
  cancelAddParty(): void {
    this.showAddPartyForm = false;
    this.currentAddPartySection = null;
    //console.log('Add Party Form Closed');
  }

  // Submit Add Party form
  submitAddParty(): void {
    //console.log(`ON submitAddParty`);
    if (this.addPartyForm.valid && !this.isAddLoading) {
      const formData = this.addPartyForm.getRawValue();
      this.isAddLoading = true; // ✅ Start loading

      const partyModel: PartyModelRequest = {
        prtType: formData.partyType,
        partiesName: formData.partyName,
        idStructureTypeName: formData.idType,
        groupPartyName: formData.partyGroupName,
        partiesId: '',
        familyName: formData.partySurname,
        istValue: formData.idNumber,
        groupPartySurname: formData.partyAdditionalInfo,
        partyTypeForGroupHead: formData.partyTypeDropdown,
        transType: 'I',
        otherIdsData: [
          {
            istId: formData.idType,
            istValue: formData.idNumber,
          },
        ],
        partiesFullName: `${formData.partyName} ${formData.partySurname || ''}`.trim(),
        groupPartyFullName: `${formData.partyGroupName} ${formData.partyAdditionalInfo}`.trim(),
      };

      const handleSuccess = (response: any, isGroup: boolean) => {
        const id = isGroup ? response.groupPartyId : response.partyId;
        const fullName = partyModel.partiesFullName;

        if (this.currentAddPartySection === 'filedBy') {
          this.searchForm2.patchValue({
            petitionerSearchName: id,
            partiesNameText: fullName,
          });
        } else if (this.currentAddPartySection === 'plaintiff') {
          this.searchForm2.patchValue({
            plaintiffSearchName: id,
            partiesPlaintiffNameText: fullName,
          });
        } else if (this.currentAddPartySection === 'defendant') {
          this.searchForm2.patchValue({
            defendantSearchName: id,
            partiesDefendantNameText: fullName,
          });
        }

        this.dialogService.openDialog1({
          data: {
            title: "Information",
            message: response.message || '',
            icon: 'info',
          }
        });

        this.cancelAddParty(); // ✅ Close the form
        this.isAddLoading = false; // ✅ Stop loading only after completion
      };

      const handleError = (error: any) => {
        console.error('Error submitting party:', error);
        this.dialogService.openDialog1({
          data: {
            title: "Error",
            message: 'Failed! Please try again.',
            icon: 'error',
          }, disableClose: true,           // Prevents closing on outside click or ESC
          hasBackdrop: true,            // Shows backdrop to block interaction
          backdropClass: 'dialog-backdrop', // Optional: custom styling
        });
        this.isAddLoading = false; // ✅ Stop loading on error too
      };

      if (formData.partyType === 'GRP') {
        this.documentDetailsService.assignGroupParty(partyModel).subscribe({
          next: (response) => handleSuccess(response, true),
          error: handleError,
        });
      } else {
        this.documentDetailsService.upsertParty(partyModel).subscribe({
          next: (response) => handleSuccess(response, false),
          error: handleError,
        });
      }

    } else {
      //console.log('Form is invalid:', this.addPartyForm.errors);
      this.dialogService.openDialog1({
        data: {
          title: "Information",
          message: 'Please fill all required fields.',
          icon: 'info',
        }, disableClose: true,           // Prevents closing on outside click or ESC
        hasBackdrop: true,            // Shows backdrop to block interaction
        backdropClass: 'dialog-backdrop', // Optional: custom styling
      });
    }
  }


  // fetch Id Types
  fetchIDTypes(): void {
    this.isIDTypeLoading = true;
    this.errorIDTypeMessage = null;

    this.documentDetailsService.getIDTypes().subscribe({
      next: (response) => {
        this.idTypeList = response.success;
        this.isIDTypeLoading = false;
      },
      error: (error) => {
        console.error('Error fetching ID Types:', error);
        this.errorIDTypeMessage = 'Failed to fetch ID Types.';
        this.isIDTypeLoading = false;
      },
    });
  }

  isPersonSelected(): boolean {
    return this.addPartyForm.get('partyType')?.value === 'PRS';
  }

  isGroupSelected(): boolean {
    return this.addPartyForm.get('partyType')?.value === 'GRP';
  }

  resetPartyTypeFields(partyType: string): void {
    if (partyType === 'GRP') {
      // Clear fields for non-group-related inputs
      this.addPartyForm.patchValue({
        // partyHeadName: '',
        partyName: '',
        // partyHeadSurname: '',
        partySurname: '',
        partyGroupName: '',
        partyTypeDropdown: '',
        idNumber: '',
        idType: '',
        partyAdditionalInfo: '',
      });
    } else if (partyType === 'PRS') {
      // Clear fields for group-related inputs
      this.addPartyForm.patchValue({
        partyName: '',
        partySurname: '',
        idNumber: '',
        idType: '',
      });
    } else {
      // Clear all fields for other cases (e.g., Corporate or Govt)
      this.addPartyForm.patchValue({
        partyName: '',
        idNumber: '',
        idType: '',
      });
    }
  }

  onCourtDivisionChange(event: MatSelectChange | any): void {
    const selectedDivision = event?.value ?? event; // Support both MatSelectChange and manual object

    if (selectedDivision) {
      //console.log('Selected Division Details:');
      this.courtUnitNameData = selectedDivision.name;
      this.courtUnitShortNameData = selectedDivision.shortName;
      this.courtUnitIdData = selectedDivision.cutId;
      if (!(this.isSupremeCourtFlg || this.isCOAFlg)) {
        this.fetchCaseTypes(selectedDivision.cutId);
      }
    } else {
      //console.log('No division selected');
    }
  }
  fetchCaseTypes(courtId: number): void {
    this.isCaseTypeLoading = true;

    this.documentDetailsService.getCaseTypesByCutId(courtId).subscribe({
      next: (response) => {
        this.caseTypeList.set(response.data || []);
        this.isCaseTypeLoading = false;
      },
      error: (error) => {
        console.error('Error fetching ID Types:', error);
        this.errorIDTypeMessage = 'Failed to fetch ID Types.';
        this.isCaseTypeLoading = false;
      },
    });
  }


  onCaseStageChange(caseStageId: number): void {
    // Find the selected case stage by ID
    const selectedCaseStage = this.caseStages.find(
      (stage) => stage.documentTypeCasePhaseTypeId === caseStageId
    );

    if (selectedCaseStage) {
      this.cptShortNameData = selectedCaseStage.phaseName || null;
      this.cptIdData = selectedCaseStage.documentTypeCasePhaseTypeId || null;
      //console.log('Selected Phase Name:', this.cptShortNameData);
    } else {
      this.cptShortNameData = null;
    }
  }

  resetFormData(): void {
    // Reset all forms to their initial state
    this.searchForm.reset();
    this.searchForm2.reset();
    this.selectedCategory = '';
    this.selectedCaseType = 0;
    this.selectedDocumentType = 0;
    this.selectedFiledOnDate = null;
    //console.log('Forms and variables reset successfully.');
  }

  onSaveSubmit(): void {

  }
  formatDateFromMillis(milliseconds: number): string {
    const date = new Date(milliseconds);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  populateFormWithCaseHandlerData(data: any[],): void {
    const caseHandlerData = data[0]; // Assuming the data array contains only one object
    const additionalDataObj = data[0]['appealRecordDto']; // Assuming the additional data array contains only one object
    if (caseHandlerData) {
      // Patch data into searchForm
      this.searchForm.patchValue({
        caseCategory: caseHandlerData.caseCategory || '',
        courtDivision: caseHandlerData.courtUnitName || '',
        caseType: caseHandlerData.ctpShortName || ''
      });

      //console.log('Updated searchForm:', this.searchForm.value);

      // Patch data into searchForm2
      this.searchForm2.patchValue({
        docTypeId: caseHandlerData.docTypeId || '',
        caseStageId: caseHandlerData.caseStageId || '',
        petitionerSearchName: caseHandlerData.partiesByPrtIdReallyIssuedBy || '',
        partiesNameText: caseHandlerData.partiesByPrtIdReallyIssuedByName || '',
        plaintiffSearchName: caseHandlerData.partiesByPrtIdIssuedBy || '',
        partiesPlaintiffNameText: caseHandlerData.partiesByPrtIdIssuedByName || '',
        defendantSearchName: caseHandlerData.partyIdCharging || '',
        partiesDefendantNameText: caseHandlerData.partyIdChargingName || '',
        filedOn: caseHandlerData.filedOn || null,
        comments: '',
        lowerCourt: caseHandlerData.appealCourtName || '',
        oldSuitNumber: caseHandlerData.oldCaseNumber || '',
        suitNumberFormData: caseHandlerData.suitNumber || '',
      });
      this.selectedCategory = caseHandlerData.caseCategory || '';
      this.selectedCaseType = caseHandlerData.caseType || 0;
      this.selectedDocumentType = caseHandlerData.docTypeId || 0;
      this.selectedFiledOnDate = caseHandlerData.filedOn || null;
      if (this.isSupremeCourtFlg && additionalDataObj) {
        this.courtOfAppealForm.patchValue({
          courtOfAppeal: additionalDataObj.courtOfAppealId && additionalDataObj.courtOfAppealName
            ? { id: additionalDataObj.courtOfAppealId, name: additionalDataObj.courtOfAppealName }
            : null,
          divisionAtCourtOfAppeal: additionalDataObj.appealDivisionId && additionalDataObj.appealDivisionName
            ? { id: additionalDataObj.appealDivisionId, name: additionalDataObj.appealDivisionName }
            : null,
          courtOfAppealCaseNo: additionalDataObj.appealCaseNo || '',
          panelOfJustices: additionalDataObj.coaJustices || '',
          appealCourtJudgmentDate: additionalDataObj.appealJudgmentDate ? this.formatDateFromMillis(additionalDataObj.appealJudgmentDate) : null,
          noticeOfAppealFiledDate: additionalDataObj.noticeFiledDate ? this.formatDateFromMillis(additionalDataObj.noticeFiledDate) : null,
          transmissionOfRecordDate: additionalDataObj.transmissionDate ? this.formatDateFromMillis(additionalDataObj.transmissionDate) : null,
          serviceOfAppealRecordDate: additionalDataObj.appealServiceDate ? this.formatDateFromMillis(additionalDataObj.appealServiceDate) : null,
          supplementaryRecordFiled: additionalDataObj.supplementaryFiled || '',
          supplementaryRecordDate: additionalDataObj.supplementaryFiledDate ? this.formatDateFromMillis(additionalDataObj.supplementaryFiledDate) : null,
        });
        this.trialCourtForm.patchValue({
          trialCourt: additionalDataObj.trialCourtId && additionalDataObj.trialCourtName
            ? { id: additionalDataObj.trialCourtId, name: additionalDataObj.trialCourtName }
            : null,
          trialCourtDivision: additionalDataObj.trialCourtDivisionId && additionalDataObj.trialCourtDivisionName
            ? { id: additionalDataObj.trialCourtDivisionId, name: additionalDataObj.trialCourtDivisionName }
            : null,
          trialJudge: additionalDataObj.trailJudges || '',
          trialCourtJudgementDate: this.formatDateFromMillis(additionalDataObj.trialJudgmentDate) || '',
          serviceOfAppellantsDate: this.formatDateFromMillis(additionalDataObj.appellantServiceDate) || '',
        });
      }
      //console.log('Updated searchForm2:', this.searchForm2.value);


    }
    const notice = this.courtOfAppealForm.get('noticeOfAppealFiledDate');
    const transmission = this.courtOfAppealForm.get('transmissionOfRecordDate');
    const service = this.courtOfAppealForm.get('serviceOfAppealRecordDate');
    if (this.isSupremeCourtFlg && caseHandlerData.ctpShortName === 'ML') {
      notice?.clearValidators();
      transmission?.clearValidators();
      service?.clearValidators();

      notice?.updateValueAndValidity();
      transmission?.updateValueAndValidity();
      service?.updateValueAndValidity();
    } else {
      notice?.setValidators([Validators.required]);
      transmission?.setValidators([Validators.required]);
      service?.setValidators([Validators.required]);

      notice?.updateValueAndValidity();
      transmission?.updateValueAndValidity();
      service?.updateValueAndValidity();
    }
  }

  validateParties(): void {
    const petitionerId = this.searchForm2.get('petitionerSearchName')?.value;
    const plaintiffId = this.searchForm2.get('plaintiffSearchName')?.value;
    const defendantId = this.searchForm2.get('defendantSearchName')?.value;

    // 1. Check duplicate parties first (applies to all case types)
    if (petitionerId && defendantId && petitionerId === defendantId) {
      this.setErrorState('Filed By/ Petitioner(s) Party and Defendant(s) Party cannot be same.');
      return;
    }

    if (plaintiffId && defendantId && plaintiffId === defendantId) {
      this.setErrorState('Plaintiff(s)/Claimant(s) Party and Defendant(s) Party cannot be same.');
      return;
    }

    // // 2. Criminal Case Validation ('CR')
    // if (this.ctpShortNameData === 'CR' && !this.isAddSearchFlag) {
    //   const isPlaintiffGovt = this.isGovernmentParty(this.plaintiffParty);
    //   const isDefendantGovt = this.isGovernmentParty(this.defendantParty);

    //   if (!isPlaintiffGovt && !isDefendantGovt) {
    //     const isAnyGroup =
    //       this.plaintiffParty?.prtType === 'GRP' ||
    //       this.defendantParty?.prtType === 'GRP';

    //     const errorMsg = isAnyGroup
    //       ? `Either 'Plaintiff(s)/Claimant(s)' or 'Defendant(s)' Party inside Group should be 'GOVT' for Case Type Criminal.`
    //       : `Either 'Plaintiff(s)/Claimant(s)' or 'Defendant(s)' Party should be 'GOVT' for Case Type Criminal.`;

    //     this.setErrorState(errorMsg);
    //     return;
    //   }
    // }

    // 3. Validation passed
    this.isValidParty = false;
    this.messageData = '';
  }

  validateDocuments(): boolean {

    const hasDocType = this.docTypeIdData !== 0 && this.docTypeIdData !== null && this.docTypeIdData !== undefined;

    if (!this.isAddSearchFlag && hasDocType && this.sessionConstant?.INITIAL_DOCUMENT_ID !== null) {
      const initialDocIds: number[] = this.sessionConstant?.INITIAL_DOCUMENT_ID
        .split('-')
        .map(id => Number(id));


      return !initialDocIds.includes(this.docTypeIdData);
    }

    return false;
  }


  /**
   * Checks if a party is GOVT directly or has GOVT presence inside a GRP.
   */
  private isGovernmentParty(party: Party | null | undefined): boolean {
    if (!party) return false;

    // Direct Government check
    if (party.prtType === 'GOVT') {
      return true;
    }

    // Group check: True if GRP and govtPartyInGroup is truthy or 'Y'
    if (party.prtType === 'GRP') {
      return party.govtPartyInGroup === 'Y';
    }

    return false;
  }

  /**
   * Sets form error state and message.
   */
  private setErrorState(message: string): void {
    this.messageData = message;
    this.isValidParty = true;
  }

  filterDocumentTypes(): void {
    const search = this.searchTerm.toLowerCase().trim();

    if (search.length === 0) {
      // Clone and sort original list
      this.filteredDocumentTypes = [...this.documentTypes].sort((a, b) =>
        a.docmentTypeName.localeCompare(b.docmentTypeName)
      );
    } else {
      this.filteredDocumentTypes = this.documentTypes
        .filter((docType) =>
          docType.docmentTypeName.toLowerCase().includes(search)
        )
        .sort((a, b) =>
          a.docmentTypeName.localeCompare(b.docmentTypeName)
        );
    }
  }

  onSearchInput(event: Event): void {
    const target = event.target as HTMLInputElement;
    if (target) {
      this.searchTerm = target.value;
      this.filterDocumentTypes();
    }
  }

  onDropdownOpened(): void {
    this.searchTerm = '';
    this.filteredDocumentTypes = [...this.documentTypes].sort((a, b) =>
      a.docmentTypeName.localeCompare(b.docmentTypeName));
    setTimeout(() => this.searchInput?.nativeElement?.focus(), 100);
  }

  setDefaultFiledOnDate(): void {
    const currentDate = new Date();
    this.selectedFiledOnDate = this.datePipe.transform(currentDate, 'dd-MMM-yyyy');
    this.searchForm2.patchValue({ filedOn: currentDate });
    //console.log('Filed on initialized to:', this.selectedFiledOnDate);
  }
  getCourtNameData(): ILoginData | null {
    try {
      const userData = localStorage.getItem('userData') as string;
      const userData2 = userData ? JSON.parse(userData) : null;
      this.courtIdData = userData2.courtId;
      this.isDivision = userData2.divisionName;
      this.isDivisionId = userData2.divisionId;
      if (userData2.divisionId !== 0) {
        this.isdivisionreadOnly = true;
        const matchedDivision = this.divisionList().find(div => div.courtUnitTypeId === this.isDivisionId)
        this.courtUnitNameData = matchedDivision?.courtUnitName || '';
        this.courtUnitShortNameData = matchedDivision?.courtUnitTypeShortName || '';
        this.courtUnitIdData = Number(matchedDivision?.courtUnitId || 0);
        this.onCourtDivisionChange(matchedDivision);

      }

      //supreme court
      if (this.sessionConstant.COURT_LEVEL === this.sessionConstant.SC_COURT_LEVEL_ID) {
        this.isSupremeCourtFlg = true;
      } else if (this.sessionConstant.COURT_LEVEL === this.sessionConstant.COA_COURT_LEVEL_ID) {
        this.isCOAFlg = true;
      }
      //console.log(`userData2 :: ${userData2}`)
      // return userData ? JSON.parse(userData) : null;
      return userData2;
    } catch (err) {
      return null
    }
  }

}